let format = (value) => {
  return value >= 10 ? value : '0' + value
}
/**
 * 时间格式化
 */
export const dateFilter = (time, type) => {
  let date = new Date(time * 1000)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let second = date.getSeconds()
  let result
  switch (type) {
    case 0: // 01-05
      result = `${format(month)}月${format(day)}日`
      break
    case 1: // 11:12
      result = `${format(hours)}:${format(minutes)}:${format(second)}`
      break
    case 2: // 2015-01-05
      result = `${year}-${format(month)}-${format(day)}`
      break
    case 3: // 2015-01-05 11:12
      result = `${year}-${format(month)}-${format(day)}  ${format(hours)}:${format(minutes)}`
      break
    case 4:// 2015-01-05 11:12:06
      result = `${year}-${format(month)}-${format(day)}  ${format(hours)}:${format(minutes)}:${format(second)}`
      break
    case 5:// Jan 05, 2015 11:12:06
      result = date.format('M dd, yyyy HH:mm:ss')
      break
    case 6:// Jan 05, 2015
      result = date.format('M dd, yyyy')
      break
    case 7:// Jan 05, 2015
      result = `${year}年${format(month)}月${format(day)}日  ${format(hours)}:${format(minutes)}`
      break
  }
  return result
}

export const dateFilter2 = (time, type) => {
  let date = new Date(time * 1000)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let second = date.getSeconds()
  let result
  switch (type) {
    case 0: // 01-05
      result = `${format(month)}-${format(day)}`
      break
    case 1: // 11:12
      result = `${format(year)}年${format(month)}月`
      break
    case 2: // 2015-01-05
      result = `${year}-${format(month)}-${format(day)}`
      break
    case 3: // 2015-01-05 11:12
      result = `${year}-${format(month)}-${format(day)}  ${format(hours)}:${format(minutes)}`
      break
    case 4:// 2015-01-05 11:12:06
      result = `${year}-${format(month)}-${format(day)}  ${format(hours)}:${format(minutes)}:${format(second)}`
      break
    case 5:// Jan 05, 2015 11:12:06
      result = date.format('M dd, yyyy HH:mm:ss')
      break
    case 6:// Jan 05, 2015
      result = date.format('M dd, yyyy')
      break
  }
  return result
}

/**
 * 字符串时间格式化
 */
export const dateFilter3 = (time, type) => {
  if (time.length <= 10) {
    time += ' 00:00:00'
  }
  let date = new Date(time)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let second = date.getSeconds()
  let result
  switch (type) {
    case 0: // 01-05
      result = `${format(month)}月${format(day)}日`
      break
    case 1: // 11:12
      result = `${format(hours)}:${format(minutes)}:${format(second)}`
      break
    case 2: // 2015-01-05
      result = `${year}-${format(month)}-${format(day)}`
      break
    case 3: // 2015-01-05 11:12
      result = `${year}-${format(month)}-${format(day)}  ${format(hours)}:${format(minutes)}`
      break
    case 4:// 2015-01-05 11:12:06
      result = `${year}-${format(month)}-${format(day)}  ${format(hours)}:${format(minutes)}:${format(second)}`
      break
    case 5:// Jan 05, 2015 11:12:06
      result = date.format('M dd, yyyy HH:mm:ss')
      break
    case 6:// Jan 05, 2015
      result = date.format('M dd, yyyy')
      break
    case 7:// Jan 05, 2015
      result = `${year}年${format(month)}月${format(day)}日  ${format(hours)}:${format(minutes)}`
      break
  }
  return result
}

Date.prototype.format = function (mask) {
  var d = this
  var zeroize = function (value, length) {
    if (!length) {
      length = 2
    }
    value = String(value)
    for (var i = 0, zeros = ''; i < (length - value.length); i++) {
      zeros += '0'
    }
    return zeros + value
  }
  return mask.replace(/"[^"]*"|'[^']*'|\b(?:d{1,4}|m{1,4}|yy(?:yy)?|([hHMstT])\1?|[lLZ])\b/g, function ($0) {
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    let monthsAll = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    switch ($0) {
      case 'd': return d.getDate()
      case 'dd': return zeroize(d.getDate())
      case 'ddd': return ['Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat'][d.getDay()]
      case 'dddd': return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][d.getDay()]
      case 'M': return months[d.getMonth()]
      case 'MM': return zeroize(d.getMonth() + 1)
      case 'MMM': return months[d.getMonth()]
      case 'MMMM': return monthsAll[d.getMonth()]
      case 'yy': return String(d.getFullYear()).substr(2)
      case 'yyyy': return d.getFullYear()
      case 'h': return d.getHours() % 12 || 12
      case 'hh': return zeroize(d.getHours() % 12 || 12)
      case 'H': return d.getHours()
      case 'HH': return zeroize(d.getHours())
      case 'm': return d.getMinutes()
      case 'mm': return zeroize(d.getMinutes())
      case 's': return d.getSeconds()
      case 'ss': return zeroize(d.getSeconds())
      case 'l': return zeroize(d.getMilliseconds(), 3)
      case 'L': var m = d.getMilliseconds()
        if (m > 99) m = Math.round(m / 10)
        return zeroize(m)
      case 'tt': return d.getHours() < 12 ? 'am' : 'pm'
      case 'TT': return d.getHours() < 12 ? 'AM' : 'PM'
      case 'Z': return d.toUTCString().match(/[A-Z]+$/)
      // Return quoted strings with the surrounding quotes removed
      default: return $0.substr(1, $0.length - 2)
    }
  })
}

export const stringUppercaseFilter = (value) => {
  if (!value) {
    return ''
  }
  value = value.toString()
  return value.toUpperCase()
}

export const processImages = (value, defaultImage = 'static/images/avatar.png') => {
  let imageUrl = value ? '' + value + '?imageView2/2/w/250/h/250/' : defaultImage
  return imageUrl
}

export const getThousandsFormat = (value) => {
  return value.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
}

export const excludeSpecial = (value) => {
  value = value.replace(/[|\;|]/g, ' ')
  return value
}
/**
 *  1.邮箱信息展示，真实数据中，邮箱前缀后缀都有比较长的；很多是用户/公司的名字。我们建议显示@前面的信息。
 * （1）若大于10个字符，中间的隐藏，*展示；（举例：nouve*tions）
 * （2）小于等于10个字符，全部展示；（举例：steve）
 * 2.手机号码还是采取现在隐藏方式，中间4位*展示。（举例：151****0021）
 * 3.若用户修改了昵称，
 * （1）超过8个字符的中间*展示；（举例：pat*and，hap*y张三）
 * （2）不超过8个字符，全部展示；（举例：martin，张三，张国荣，站似一棵松啊）
 * @param {*}字符串
 */
export const getStarFormat = (value) => {
  if (!value) {
    return
  }
  let reg = new RegExp('^([a-zA-Z\\d_.-]+)@([\\da-z.-]+)\\.([a-z.]{2,5})$')
  if (reg.test(value)) {
    let index = value.indexOf('@')
    let newValue = value.substring(0, index)
    if (newValue.length > 10) {
      return newValue.replace(newValue.substring(5, newValue.length - 5), '*')
    } else {
      return newValue
    }
    // return value.replace(value.substring(1, index - 1), '*')
  }
  if (Number(value) && value.length === 11) {
    return value.substring(0, 3) + '****' + value.substring(7)
  }
  // if (value.length > 15) {
  //   return value.substring(0, 14) + '****'
  // }
  if (value.length > 8) {
    return value.replace(value.substring(4, value.length - 4), '*')
  } else {
    return value
  }
}

export const getordertitle = (value) => {
  if (!value) {
    return
  }
  if (value.length > 15) {
    return value.substring(0, 14) + '***'
  } else {
    return value
  }
}

/**
 * 显示文本为 "*******"
 * @author liqiang
 * @param {String} value 需要设置为*的文本
 */
export const getPasswordFormat = (value) => {
  for (let i = 0; i < value.length; i++) {
    value.charAt(i).replace('*')
  }
  return value
}

/**
 * 区号前 加 + 符号
 * @author liqiang
 * @param {String} value 需要设置的区号
 */
export const getZoneFormat = (value) => {
  return `+${value}`
}

export const getImageUrl = (value, w, h) => {
  return `${global.QINIU_IMAGE_SERVER}${value}?imageView2/1/w/${w}/h/${h}`
}

export const getImageUrl3 = (value, w, h) => {
  if (value.includes('?imageMogr2')) {
    return `${global.QINIU_IMAGE_SERVER}${value}/thumbnail/${w}x${h}!`
  } else {
    return `${global.QINIU_IMAGE_SERVER}${value}?imageView2/1/w/${w}/h/${h}`
  }
}

export const getImageUrl2 = (value, w) => {
  return `${global.QINIU_IMAGE_SERVER}${value}?imageView2/2/w/${w}`
}

export const getImageUrl4 = (value, h) => {
  return `${global.QINIU_IMAGE_SERVER}${value}?imageView2/2/h/${h}`
}

export const getOriginalImageUrl = (value) => {
  return `${global.QINIU_IMAGE_SERVER}${value}`
}

/**
 * 转赠用户名规则
 * @param {String} value
 */
export const getStarFormatForDonate = (value) => {
  if (!value) {
    return
  }

  if (value.length > 8) {
    return value.replace(value.substring(4, value.length - 4), '*')
  } else {
    return value.replace(value.substring(0, 1), '*')
  }
}

/**
 * 去除收尾空格
 * @param {String} value
 */
export const trimHelper = (value) => {
  if (!value) {
    return
  }
  return value.trim()
}

export const keepDecimal = (value, precision = 2) => {
  return Number(value).toFixed(precision)
}

/**
 * 克隆对象
 * @param {Object} value
 */
export const cloneObject = (obj) => {
  let newObj = {}
  if (obj instanceof Array) {
    newObj = []
  }
  for (var key in obj) {
    let val = obj[key]
    if (val === null) {
      newObj[key] = null
    } else if (val instanceof Date) {
      newObj[key] = val
      console.log(val)
    } else {
      newObj[key] = typeof val === 'object' ? cloneObject(val) : val
    }
  }
  return newObj
}
